/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import Framework from '@greenville/framework';
import Unauthorized from './Unauthorized';

const ErrorContainer = () => {
  useEffect(() => {
    Framework.redirectTo('/unauthorized');
  }, []);
  return <Route path="/unauthorized" render={() => <Unauthorized />} />;
};

export default ErrorContainer;
